import React from 'react';

const Add = ({ width = 12, height = 12, color = '#494949' }) => (
  <svg className="svg-icon" height={height} width={width} viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg">
    <title>e add</title>
    <g fill={color}>
      <path d="M11,5H7V1A1,1,0,0,0,5,1V5H1A1,1,0,0,0,1,7H5v4a1,1,0,0,0,2,0V7h4a1,1,0,0,0,0-2Z" fill={color} />
    </g>
  </svg>
);

export default Add;
